export var convertToPaginatedType = function (nestedConverter) {
    return function (result) {
        return {
            pagination: {
                hasNextPage: result.hasNextPage,
                hasPreviousPage: result.hasPreviousPage,
                pageNumber: result.pageNumber,
                pageSize: result.pageSize,
                totalCount: result.totalCount,
                totalPages: result.totalPages,
            },
            items: result.items.map(nestedConverter),
        };
    };
};
